// Loader lazy de páginas do app moderno (Fase 1.1 do MODERNIZACAO.md).
// Cada página migrada vive em src/pages/{modulo}/index.ts exportando
// init(context?) e vira um chunk próprio no build (import.meta.glob).
// As páginas legadas continuam no fluxo Page.load de src/js/page.js.

type PageModule = {
  init?: (context?: unknown) => Promise<(() => void) | void> | (() => void) | void
}

const pages = import.meta.glob<PageModule>(['../pages/*/index.ts', '../pages/*/*/index.ts'])

export function hasPage(page: string): boolean {
  return `../pages/${page}/index.ts` in pages
}

/**
 * Carrega e inicializa uma página migrada. Retorna o cleanup devolvido
 * pelo init() da página (unsubscribe de stores etc.), se houver.
 */
export async function loadPage(page: string, context?: unknown): Promise<(() => void) | void> {
  const loader = pages[`../pages/${page}/index.ts`]
  if (!loader) {
    throw new Error(`Página não migrada: ${page}`)
  }
  const mod = await loader()
  return mod.init?.(context)
}
